export default "__VITE_ASSET__CZQGMeZv__"